import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-participatie-like',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconParticipatieLike {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M10 17.01V29c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V17.01c0-.55.45-1 1-1h6c.55 0 1 .45 1 1m24 .08c0-1.15-.94-2.09-2.09-2.09H23a1.005 1.005 0 0 1 0-2.01h2v-2.12c-.02-1.89-.02-2.96-.35-4.67-.55-2.85-1.74-3.21-2.4-3.21-.94 0-1.5.85-1.5 1.68v.38c0 6.47-3.44 11.82-8.74 11.95v11.99h.23c1.49 0 2.5.03 3.65.54l.37.16c1.41.63 3.06 1.3 5.74 1.3h7c.37 0 .53-.03.6-.12.81-.29 1.39-1.06 1.39-1.96 0-.8-.46-1.5-1.13-1.85h.04c1.15 0 2.09-.94 2.09-2.09 0-.8-.46-1.5-1.13-1.85h.04c1.15 0 2.09-.94 2.09-2.09 0-.8-.46-1.5-1.13-1.85h.04c1.15 0 2.09-.94 2.09-2.09Z"/>
</svg>

    );
  }
}
